import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import pl from './locales/pl.json';
import de from './locales/de.json';
import es from './locales/es.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import fr from './locales/fr.json';

const userLang = localStorage.getItem('lang') || navigator.language.slice(0, 2) || 'en';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            pl: { translation: pl },
            en: { translation: en },
            de: { translation: de },
            fr: { translation: fr },
            es: { translation: es },
            zh: { translation: zh },
            ja: { translation: ja },
        },
        lng: userLang,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;